import { Alarm } from '@/Interface/alarm';
import { PlantList } from '@/Interface/plants';
import { ClusterPlants, StationData } from '@/Interface/regionAndCity';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '@services/utility.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
@Component({
  selector: 'app-cluster',
  templateUrl: './cluster.component.html',
  styleUrls: ['./cluster.component.scss']
})
export class ClusterComponent implements OnInit {

  @ViewChild('search', { static: false }) search: any;
  plantName: any;
  stationName: any;
  filteredRow: any[] = [];
  esnCode: any;
  devName: any;
  loader: boolean;
  isLoadingTable: boolean;
  isLoadingTableInner: boolean;
  dtOptions: DataTables.Settings = {};
  @ViewChild('myTable') table: any;
  rows: any[] = [];
  pageSize: number;
  searchElement = "";
  selectedRowIds: number[] = [];
  columnCheckboxSelected: boolean
  clearAllButtonDisabled: boolean = true;
  serialNumberArray: Array<number> = [];
  private latestQueryParams: any = {};
  sortColumn: string = null;
  sortOrder: 'asc' | 'desc' = null;
  pageToGo: number = 1;

  alarmList: Alarm;
  alarmDetailsItem: Alarm;
  clusterPlants: ClusterPlants[] = []
  emiPlants: StationData[] = []
  selectedRows: StationData[] = [];
  checkedMap: { [devId: string]: boolean } = {};
  maxSelectable = 2;
  movedStations: StationData[] = []; // the destination
  row: Alarm | any;
  alarmInfo: Alarm;
  dtTrigger: Subject<any> = new Subject<any>();
  public pageSizeControl = new FormControl(10);
  public pageRecordOptions = [
    { value: '10', label: '10' },
    { value: '25', label: '25' },
    { value: '50', label: '50' },
    { value: '100', label: '100' }
  ];
  public selectedPlant: PlantList | null;
  @ViewChild('clusterRadius') clusterRadiusInput!: ElementRef<HTMLInputElement>;
  @ViewChild('emiRadius', { static: false }) emiRadiusInput!: ElementRef<HTMLInputElement>;
  clusterValue: number = 10;
  emiValue: number = 10;

  constructor(
    private _utiltiySevice: UtilityService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private _appService: AppService,
    private _route: ActivatedRoute,
    private _router: Router,
  ) {
    this._utiltiySevice.getSelectedPlant$().subscribe((plant: PlantList | null) => {
      this.selectedPlant = plant;
    });
  }

  ngOnInit(): void {
    this.loader = true;
    const stationCode = this._route.snapshot.paramMap.get('id');

    // The URL is the source of truth. After a refresh or on a deep link the
    // service has no plant, so re-fetch the one named by the :id param before
    // loading the table (which needs its latitude/longitude).
    if (stationCode && this.selectedPlant?.stationCode !== stationCode) {
      this.loadPlantByStationCode(stationCode);
      return;
    }

    if (!this.selectedPlant) {
      this.loader = false;
      this.showPlantList();
      return;
    }

    this.getTableData();
    setTimeout(() => {
      this.loader = false;
    }, 250);
  }

  private loadPlantByStationCode(stationCode: string): void {
    this._appService
      .getAllPlantsdetails(stationCode, 1, 10, null, null, null, null, null, null, null)
      .subscribe({
        next: (res: any) => {
          const match = (res?.data || []).find(
            (plant: any) => String(plant.stationCode) === String(stationCode)
          );
          if (match) {
            this._utiltiySevice.updateSelectedPlant(match);
            this.getTableData();
            this.loader = false;
            return;
          }
          // The list search didn't surface it — fall back to a full scan.
          this.findPlantInFullList(stationCode);
        },
        error: () => this.findPlantInFullList(stationCode)
      });
  }

  private findPlantInFullList(stationCode: string): void {
    this._appService
      .getAllPlantsdetails(null, 1, 1000, null, null, null, null, null, null, null)
      .subscribe({
        next: (res: any) => {
          const match = (res?.data || []).find(
            (plant: any) => String(plant.stationCode) === String(stationCode)
          );
          this.loader = false;
          if (match) {
            this._utiltiySevice.updateSelectedPlant(match);
            this.getTableData();
          } else {
            this.toastr.error('Plant not found.');
            this.showPlantList();
          }
        },
        error: () => {
          this.loader = false;
          this.toastr.error('Unable to load plant details.');
          this.showPlantList();
        }
      });
  }


  sortAlarms(column: string): void {
    if (this.sortColumn === column) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortOrder = 'asc';
    }

    let sortValue: string | null = null;
    let columnName: string;

    if (this.sortOrder === 'asc') {
      sortValue = '0';
    } else if (this.sortOrder === 'desc') {
      sortValue = '1';
    }

    // Mapping column names used in the template to the corresponding column names expected by the API
    switch (column) {
      case 'alarmName':
        columnName = 'alarmName';
        break;
      case 'devName':
        columnName = 'devName';
        break;
      default:
        columnName = column;
        break;
    }

    this.updateQueryParams({ sort: sortValue, column: columnName });
  }

  // private updateQueryParams(paramsToUpdate: any): void {
  //   this.latestQueryParams = {
  //     ...this.latestQueryParams,
  //     ...paramsToUpdate
  //   };
  //   console.log('Updated queryParams:', this.latestQueryParams);

  //   if (this.latestQueryParams.search === '') {
  //     this.latestQueryParams.search = null;
  //   }
  //   if (this.latestQueryParams.page === 1) {
  //     this.latestQueryParams.page = null;
  //   }

  //   if (this.latestQueryParams.size === 10) {
  //     this.latestQueryParams.size = null;
  //   }
  //   if (this.latestQueryParams.sort === null) {
  //     delete this.latestQueryParams.sort;
  //   }

  //   if (this.latestQueryParams.column === null) {
  //     delete this.latestQueryParams.column;
  //   }
  //   if (this.latestQueryParams.page === 1 || (this.latestQueryParams.page && (this.latestQueryParams.search || this.latestQueryParams.department_id || this.latestQueryParams.designation_id))) {
  //     if (this.latestQueryParams.page > 1) {
  //       this.latestQueryParams.page = paramsToUpdate.page;
  //       if (this.latestQueryParams.size > 10) {
  //         this.latestQueryParams.size = paramsToUpdate.size;
  //       }
  //     } else {
  //       this.latestQueryParams.page = null;
  //     }
  //   }
  //   if (!this.next_page && (paramsToUpdate.size || paramsToUpdate.search)) {
  //     // Only include size or search in the query params
  //     this.latestQueryParams = {
  //       size: paramsToUpdate.size || null,
  //       search: paramsToUpdate.search || null
  //     };
  //   }


  //   this.getTableData();
  // }

  private updateQueryParams(paramsToUpdate: any): void {
    // Merge old params with new ones
    this.latestQueryParams = {
      ...this.latestQueryParams,
      ...paramsToUpdate
    };

    // Convert empty strings to null
    if (this.latestQueryParams.search === '') this.latestQueryParams.search = null;
    if (this.latestQueryParams.size === 10) this.latestQueryParams.size = null;
    if (this.latestQueryParams.sort === null) delete this.latestQueryParams.sort;
    if (this.latestQueryParams.column === null) delete this.latestQueryParams.column;

    // Include radius in filter change detection
    const filterKeys = ['search', 'department_id', 'designation_id', 'size', 'sort', 'column', 'radius'];
    const hasFiltersChanged = Object.keys(paramsToUpdate).some(key => filterKeys.includes(key));


    // Reset page to 1 when any filter changes
    if (hasFiltersChanged) {
      this.latestQueryParams.page = 1;
    }
    this.getTableData();
  }

  allowOnlyNumbers(event: KeyboardEvent): void {
    // Allow control keys like backspace, tab, arrows
    if (['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(event.key)) {
      return;
    }
    // Block anything that's not a digit
    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }

  blockInvalidPaste(event: ClipboardEvent): void {
    const pastedData = event.clipboardData?.getData('text') || '';
    // Block paste if it contains non-digits
    if (!/^\d+$/.test(pastedData)) {
      event.preventDefault();
    }
  }


  onShowCluster(): void {
    this.updateQueryParams({ radius: this.clusterValue });
  }
  public getTableData(): void {
    const name = this.latestQueryParams['search'] || this.searchElement;
    const page = this.latestQueryParams['page'] ? +this.latestQueryParams['page'] : 1;
    const size = this.latestQueryParams['size'] ? +this.latestQueryParams['size'] : 10;
    const sort = this.latestQueryParams['sort'] || null;
    const column = this.latestQueryParams['column'] || null;
    const lat = this.selectedPlant['latitude'] || null;
    const lng = this.selectedPlant['longitude'] || null;
    const radius = this.latestQueryParams['radius'] !== undefined
      ? +this.latestQueryParams['radius']
      : (this.clusterValue || 10);
    this.getPlantListNearby(name, page, size, sort, column, lat, lng, radius);
  }
  getEmiStations(input: HTMLInputElement | number): void {
    let radius: number;

    if (typeof input === 'number') {
      radius = input;
    } else {
      const value = parseInt(input.value, 10);
      radius = isNaN(value) ? 10 : Math.max(10, Math.min(value, 500));
    }
    const lat = this.selectedPlant['latitude'] || null;
    const lng = this.selectedPlant['longitude'] || null;
    this.isLoadingTableInner = true;
    this.emiPlants = [];
    this._utiltiySevice
      .getNearbyEmiStations(lat, lng, radius)
      .subscribe((res: any) => {
        if (res && res['success'] === true) {
          this.emiPlants = res.data;
          this.emiPlants = res.data.map(item => ({ ...item, selected: false }));
        }
        this.isLoadingTableInner = false;
      });
    setTimeout(() => {
      this.isLoadingTableInner = false;
    }, 250);
  }
  getPlantListNearby(
    name: string,
    page: number,
    size: number,
    sort: string | null,
    column: string | null,
    lat: number,
    lng: number,
    radius: number
  ): void {
    this.isLoadingTable = true;

    this._utiltiySevice.getNearbyPlants(name, page, size, sort, column, lat, lng, radius)
      .subscribe({
        next: (res: any) => {
          if (res && res.status === 200) {
            const data = res.data || [];

            this.clusterPlants = data.map((cluster: any, index: number) => ({
              ...cluster,
              selected: false,
              clearButtonDisabled: true,
              srNo: (res.current_page - 1) * size + index + 1
            }));

            this.current_page = res.current_page;
            this.next_page = res.next_page;
            this.previous_page = res.previous_page;
            this.total_pages = res.total_pages;
            this.total_items = res.total_records;
            this.enablePagination();
          }
          this.isLoadingTable = false;
        },
        error: () => {
          this.isLoadingTable = false;
          this.clusterPlants = []; // clear on error if needed
        }
      });
  }
  public searchData(event: Event): void {
    this.searchElement = (event.target as HTMLInputElement)?.value || '';
    if (this.searchElement.trim() === '') {
      this.updateQueryParams({ search: null });
    } else {
      this.updateQueryParams({ search: this.searchElement });
    }
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.total_pages) {
      this.updateQueryParams({ page });
    }
  }

  navigatePage(direction: string): void {
    if (direction === 'prev' && this.current_page > 1) {
      this.goToPage(this.current_page - 1);
    } else if (direction === 'next' && this.next_page !== null) {
      this.goToPage(this.current_page + 1);
    }
  }

  // Add a method to navigate to the entered page
  navigateToPage(): void {
    if (this.pageToGo >= 1 && this.pageToGo <= this.total_pages) {
      this.goToPage(this.pageToGo);
    }
  }

  public changePageSize(): void {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.pageSize = this.pageSizeControl.value!;
    this.updateQueryParams({ size: this.pageSize })
  }

  onSort(event: any): void {
    const sortBy = event.sorts[0];

    // Assuming your data is an array of objects (this.alarmList), use Array.prototype.sort()
    this.clusterPlants.sort((a, b) => {
      const valueA = a[sortBy.prop];
      const valueB = b[sortBy.prop];

      if (typeof valueA === 'number' && typeof valueB === 'number') {
        // Compare numbers directly
        return sortBy.dir === 'asc' ? valueA - valueB : valueB - valueA;
      } else if (
        typeof valueA === 'string' &&
        typeof valueB === 'string'
      ) {
        // Compare strings using localeCompare
        return sortBy.dir === 'asc'
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      } else {
        // Fallback to comparing as strings
        return String(valueA).localeCompare(String(valueB));
      }
    });
  }
  showPlantList() {
    this._utiltiySevice.setUrl(false);
    this._router.navigate(['/plant-management/plants']);
  }
  // ------------------------------------------------------------ Cluster -------------------------------------------------------n
  openModal(contentupdate: any) {
    this.getEmiStations(10)
    this.modalService.open(contentupdate, { size: 'xl', windowClass: 'new-custom modal-xxl', centered: true });
  }
  incrementRadius(): void {
    if (this.clusterValue + 10 <= 500) {
      this.clusterValue += 10;
    }
  }

  // decrementRadius(): void {
  //   if (this.clusterValue - 10 >= 10) {
  //     this.clusterValue -= 10;
  //   }
  // }
  decrementRadius(): void {
  if (this.clusterValue - 10 >= 1) {
    this.clusterValue -= 10;
  }
}

  incrementEmi(): void {
    if (this.emiValue + 10 <= 500) {
      this.emiValue += 10;
    }
  }

decrementEmi(): void {
  if (this.emiValue - 10 >= 1) {
    this.emiValue -= 10;
  }
}
  // decrementEmi(): void {
  //   if (this.emiValue - 10 >= 10) {
  //     this.emiValue -= 10;
  //   }
  // }

  increment(input: HTMLInputElement) {
    input.stepUp();
    this.enforceLimits(input);
  }

  decrement(input: HTMLInputElement) {
    input.stepDown();
    this.enforceLimits(input);
  }

  enforceLimits(input: HTMLInputElement) {
    let value = parseInt(input.value, 10);

    if (isNaN(value)) {
      input.value = '10';
    } else if (value < 10) {
      input.value = '10';
    } else if (value > 500) {
      input.value = '500';
    }
  }

  onCheckboxChange(event: Event, row: any): void {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (isChecked) {
      if (this.selectedRows.length >= this.maxSelectable) {
        this.toastr.warning('You can only select 2 stations.');
        // reset checkbox in UI
        (event.target as HTMLInputElement).checked = false;
        return;
      }

      this.selectedRows.push(row);
      this.checkedMap[row.devId] = true;
    } else {
      this.selectedRows = this.selectedRows.filter(
        (item) => item.devId !== row.devId
      );
      this.checkedMap[row.devId] = false;
    }
  }
  // moveSelectedRecords(): void {
  //   if (this.selectedRows.length === 0) {
  //     alert('No records selected.');
  //     return;
  //   }

  //   if (this.movedStations.length + this.selectedRows.length > this.maxSelectable) {
  //     alert('Only 2 records can be moved. Remove a record first.');
  //     return;
  //   }

  //   this.movedStations.push(...this.selectedRows.map(row => ({ ...row })));

  //   // Clear selections
  //   this.selectedRows.forEach(row => this.checkedMap[row.devId] = false);
  //   this.selectedRows = [];
  // }
  moveSelectedRecords(modal: any): void {
    if (this.selectedRows.length === 0) {
      this.toastr.warning('No records selected')
      return;
    }

    if (this.movedStations.length + this.selectedRows.length > this.maxSelectable) {
      this.toastr.warning('Only 2 records can be moved. Remove a record first.')
      return;
    }

    this.movedStations.push(...this.selectedRows.map(row => ({ ...row })));

    // Mark moved ones as checked (so they stay visually selected)
    this.selectedRows.forEach(row => this.checkedMap[row.devId] = true);

    // Clear selection buffer
    modal.dismiss('Cross click')
    this.resetSelection()
  }
  removeFromMovedStations(devId: number): void {
    this.movedStations = this.movedStations.filter(item => item.devId !== devId);
    delete this.checkedMap[devId];
  }

  // removeFromMovedStations(devId: string): void {
  //   const id = parseInt(devId, 10);
  //   this.movedStations = this.movedStations.filter(item => item.devId !== id);
  // }
  isMoved(devId: number): boolean {
    return this.movedStations.some(item => item.devId === devId);
  }
  resetSelection(): void {
    this.selectedRows = [];
    this.checkedMap = {};
    this.emiValue = 10
  }




  // ------------------------------------------------------------ Ticket List -------------------------------------------------------n
  next_page: number;
  current_page: number;
  filtered_page: number;
  previous_page: number;
  last_page: number;
  total_pages: number;
  total_items: number;

  enablePagination() {
    const linkElement = document.getElementById('prevPage');

    if (this.previous_page === null) {
      linkElement.setAttribute('disabled', 'true');
      linkElement.style.pointerEvents = 'none';
      linkElement.style.color = 'gray'; // You can set the color to indicate it's disabled
      linkElement.addEventListener('click', (event) => {
        event.preventDefault(); // Prevent the default behavior (navigation)
      });
    } else {
      linkElement.removeAttribute('disabled');
      linkElement.style.pointerEvents = 'auto'; // Enable clicking
      linkElement.style.color = ''; // Reset the color to its default
      linkElement.removeEventListener('click', (event) => {
        event.preventDefault();
      });
    }
  }
}
